import { call, put } from 'redux-saga/effects';
import LoginActions from '../redux/LoginRedux';
import { ApiResponse } from '../services/Api';
import { api } from './api';

// attempts to login
export function* login(action: any) {
  const { email, password, notificationToken, locale } = action;
  
  try {
    // make the call to the api
    const response: ApiResponse = yield call(api.login, email, password, notificationToken, locale);
    console.log("response", response);
    
    if (response.ok) {
      const { access_token } = response.data.data;
      
      // Save token first (matching reference project order)
      yield put(LoginActions.saveToken(access_token));
      
      // dispatch successful logins
      yield put(LoginActions.loginSuccess(access_token));
      
      // Set the token in API headers for future requests
      if (typeof api.setUserToken === 'function') {
        api.setUserToken(access_token);
      }
    } else {
      // dispatch failure
      yield put(LoginActions.loginFailure());
    }
  } catch (error) {
    // dispatch failure
    yield put(LoginActions.loginFailure());
  }
}

